<template>
  <a-modal
    :visible="visible"
    :title="'Chi tiết nhận hàng của đơn ' + modelObject.preOrderNo + ' trong kho ' + modelObject.warehouseName"
    @cancel="closePopup"
    width="75%"
    :maskClosable="false"
    :destroyOnClose="false"
    :footer="false"
  >
    <a-spin :spinning="loading">
      <a-card style="border: none; padding: 0px 10px">
        <a-form-model :model="form" ref="ruleForm">
          <a-row :gutter="16">
            <a-col :xs="24" :md="24" :lg="24">
              <a-row :gutter="16" type="flex">
                <a-col :span="24">
                  <a-table
                    ref="tb1"
                    :columns="columnsDetail"
                    :data-source="data"
                    :rowKey=" (rowKey, index ) => index"
                    :pagination="data.length === 0 ? false : pagination"
                    :scroll="{ x: '100%' }"
                    :locale="{ emptyText: 'Chưa có dữ liệu' }"
                    @change="handleTableChange"
                    class="ant-table-bordered">
                    <template slot="actionTitle">
                      <a-icon type="control" :style="{fontSize: '14px'}"/>
                    </template>
                    <template slot="rowIndex" slot-scope="text, record, index">
                      <span>{{ getTableRowIndex(pagination.pageSize, pagination.current, index) }} </span>
                    </template>
                  </a-table>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :xs="24" :md="24" :lg="24">
              <div style="display: flex; justify-content: space-between; margin: 15px">
                <div>
                  <p>Tổng số kiện chưa nhập: <span>{{ modelObject.notYetImport }}</span></p>
                </div>
                <div>
                  <p>Tổng số kiện đã nhập: <span>{{ modelObject.imported }}</span></p>
                </div>
                <div>
                  <p>Tổng số kiện đã xuất: <span>{{ modelObject.exported }}</span></p>
                </div>
              </div>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :xs="24" :md="24" :lg="24">
              <div style="display: flex; justify-content: center">
                <a-button type="primary" :loading="loading" @click="exportListNotImport('xlsx')">
                  Xuất danh sách chưa nhập
                </a-button>
                <a-button type="primary" :loading="loading" @click="exportListImported('xlsx')" style="margin-left: 10px">
                  Xuất danh sách đã nhập
                </a-button>
                <a-button type="primary" :loading="loading" @click="exportListExported('xlsx')" style="margin-left: 10px">
                  Xuất danh sách đã xuất
                </a-button>
              </div>
            </a-col>
          </a-row>
        </a-form-model>
      </a-card>
    </a-spin>
  </a-modal>
</template>
<script>

import columnsDetail from './columnsDetail'
import { detailImportReport, exportImportReport } from '@/api/Report/import'
import _merge from 'lodash/merge'
import moment from 'moment'

export default {
  props: {
    visibleDetail: {
      type: Boolean,
      required: true,
      default: false
    },
    modelObject: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      columnsDetail,
      form: {

      },
      data: [],
      expandedRowKeys: [],
      pagination: {
        current: 1,
        total: 1,
        pageSize: 15,
        pageSizes: 500,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['15', '25', '50'],
        showTotal: (total) => {
          return 'Tổng số dòng ' + total
        }
      },
      loading: false
    }
  },
  mounted () {
    if (this.visibleDetail === true) {
      this.visible = true
    } else {
      this.visible = false
    }
    if (this.modelObject) {
      this.form = this.modelObject
      this.findById()
    } else {
      this.form = {}
    }
  },
  methods: {
    closePopup () {
      this.visible = false
      this.$emit('closePopup')
    },
    findById () {
      const params = {
        warehouseId: this.modelObject.warehouseId,
        preOrderId: this.modelObject.preOrderId
      }
      this.loading = true
      detailImportReport(params).then(rs => {
        if (rs) {
          this.data = this.convertPropToDisplayDate(rs)
          this.pagination = _merge(this.pagination, this.handlePaginationData(rs))
        }
      }).catch(err => {
        const msg = this.handleApiError(err)
        this.$notification.error({
          message: '',
          description: msg,
          duration: 5
        })
      }).finally(res => {
        this.loading = false
      })
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = pagination
    },

    // Xuất báo cáo danh sách chưa nhập
    exportListNotImport (type) {
      const params = {
        reportName: 'rp_import_detail_not_yet_import',
        fileType: type,
        fileName: 'Danh_sach_kien_hang_cua_don_' + this.modelObject.preOrderNo + '_chua_nhap_kho_' + this.modelObject.warehouseName,
        params: {
          warehouseId: this.modelObject.warehouseId,
          preOrderId: this.modelObject.preOrderId,
          preOrderNo: this.modelObject.preOrderNo,
          warehouseName: this.modelObject.warehouseName
        }
      }
      this.loading = true
      exportImportReport(params)
        .then(rs => {
          const fileName = 'Bao_cao_danh_sach_chua_nhap_hang_' + moment().format('dd_MM_yyyy_HH_mm') + '.' + type
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(rs, fileName)
          } else {
            const downloadLink = window.document.createElement('a')
            downloadLink.href = window.URL.createObjectURL(rs)
            downloadLink.download = fileName
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
          }
        }).catch(err => {
          const msg = this.handleApiError(err)
          this.$error({ content: msg })
        }).finally(res => {
          this.loading = false
        })
    },

    // Xuất báo cáo danh sách đã nhập
    exportListImported (type) {
      const params = {
        reportName: 'rp_import_detail_imported',
        fileType: type,
        fileName: 'Danh_sach_kien_hang_cua_don_' + this.modelObject.preOrderNo + '_da_nhap_kho_' + this.modelObject.warehouseName,
        params: {
          warehouseId: this.modelObject.warehouseId,
          preOrderId: this.modelObject.preOrderId,
          preOrderNo: this.modelObject.preOrderNo,
          warehouseName: this.modelObject.warehouseName
        }
      }
      this.loading = true
      exportImportReport(params)
        .then(rs => {
          const fileName = 'Bao_cao_danh_sach_da_nhap_' + moment().format('dd_MM_yyyy_HH_mm') + '.' + type
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(rs, fileName)
          } else {
            const downloadLink = window.document.createElement('a')
            downloadLink.href = window.URL.createObjectURL(rs)
            downloadLink.download = fileName
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
          }
        }).catch(err => {
          const msg = this.handleApiError(err)
          this.$error({ content: msg })
        }).finally(res => {
          this.loading = false
        })
    },

    // Xuất báo cáo danh sách đã xuất
    exportListExported (type) {
      const params = {
        reportName: 'rp_import_detail_exported',
        fileType: type,
        fileName: 'Danh_sach_kien_hang_cua_don_' + this.modelObject.preOrderNo + '_da_xuat_kho_' + this.modelObject.warehouseName,
        params: {
          warehouseId: this.modelObject.warehouseId,
          preOrderId: this.modelObject.preOrderId,
          preOrderNo: this.modelObject.preOrderNo,
          warehouseName: this.modelObject.warehouseName
        }
      }
      this.loading = true
      exportImportReport(params)
        .then(rs => {
          const fileName = 'Bao_cao_nhap_hang_' + moment().format('dd_MM_yyyy_HH_mm') + '.' + type
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(rs, fileName)
          } else {
            const downloadLink = window.document.createElement('a')
            downloadLink.href = window.URL.createObjectURL(rs)
            downloadLink.download = fileName
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
          }
        }).catch(err => {
          const msg = this.handleApiError(err)
          this.$error({ content: msg })
        }).finally(res => {
          this.loading = false
        })
    }
  }
}
</script>
